import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { toast } from 'react-toastify';
import sucursalService from "../../services/sucursal.service";

const initialSucursal = {
    nombre: "",
    direccion: "",
    ciudad: ""
}

const Sucursal = () => {
    const [sucursal, setSucursal] = useState(initialSucursal);
    const [sucursales, setSucursales] = useState([]);
    const [formerrors, setFormErrors] = useState({});

    useEffect(() => {
        retreiveSucursales();
    }, []);

    const handleChangeSucursal = (valor, nombre) => {
        setSucursal({ ...sucursal, [nombre]: valor });
    }

    const validarForm = () => {
        console.log("Validando el formulario....");
        let errors = {};
        //name field
        if (sucursal.nombre === "") {
            errors.nombre = "Debe seleccionar una sucursal";
        }

        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const agregarSucursal = () => {
        if (!validarForm(sucursal)) {
            return;
        }

        //Ingresarmos sucursal
        sucursalService.create(sucursal)
            .then(data => {
                console.log(data.data);
                toast.info("Sucursal agregada exitosamente!", {
                    position: "top-center",
                    autoClose: 2000
                });
                retreiveSucursales();
            })
            .catch(err => {
                console.error(err);
                toast.error("Ocurrio un error al ingresar!", {
                    position: "top-center",
                    autoClose: 2000
                });
            });
    }

    function retreiveSucursales() {
        sucursalService.getAll()
            .then(data => {
                setSucursales(data.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    function despuesDeInsertar(row, cellName, cellValue) {
        let data = {};
        if (cellName === "ciudad") {
            //editamos la ciudad
            data.ciudad = cellValue;
        }
        if (cellName === "direccion") {
            data.direccion = cellValue;
        }
        sucursalService.updateSucursal(row.id, data)
            .then(d => {
                toast.info(d.data.message, {
                    position: "top-center",
                    autoClose: 2000
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    const cellEditProp = {
        mode: 'click', // a hook for before saving cell
        afterSaveCell: despuesDeInsertar  // a hook for after saving cell
    };

    function buttonFormat(cell, row) {
        return <Button variant="danger" onClick={() => eliminarSucursal(row.id)}><FontAwesomeIcon icon="fa-solid fa-trash-can" /></Button>;
    }

    const eliminarSucursal = (id) => {
        if (window.confirm("Esta seguro de eliminar la Sucursal?")) {
            sucursalService.eliminarSucursal(id)
                .then(data => {
                    toast.info(data.data.message, {
                        position: "top-center",
                        autoClose: 2000
                    });
                    retreiveSucursales();
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    return (
        <Container>
            <Row>
                <Col sm={4}>
                    <h4>Registrar Sucursal</h4>
                    <Form.Group>
                        <Form.Label>Nombre:</Form.Label>
                        <Form.Select value={sucursal.nombre != "" ? sucursal.nombre : ""} onChange={(e) => handleChangeSucursal(e.target.value, "nombre")}>
                            <option value="">Seleccione una sucursal ...</option>
                            <option value="CLINISERVICE">CLINISERVICE</option>
                            <option value="LABORATORIO MEDINORT">LABORATORIO MEDINORT</option>
                            <option value="LABORATORIO PAUL EHRLICH">LABORATORIO PAUL EHRLICH</option>
                            <option value="WORK MED">WORK MED</option>
                            <option value="LABORATORIO CMT">LABORATORIO CMT</option>
                            <option value="LABORATORIO CEM">LABORATORIO CEM</option>
                            <option value="CEIM">CEIM</option>
                            <option value="MUTUAL">MUTUAL</option>
                            <option value="PREVENIR SALUD">PREVENIR SALUD</option>
                            <option value="EXPRESSA MÉDICA">EXPRESSA MÉDICA</option>
                            <option value="ACHS">ACHS</option>
                        </Form.Select>
                        {/* <Form.Control type="text" value={sucursal.nombre} onChange={(e)=>handleChangeSucursal(e.target.value, "nombre")} /> */}
                        {formerrors.nombre && (
                            <p className="text-warning">{formerrors.nombre}</p>
                        )}
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Ciudad:</Form.Label>
                        <Form.Control type="text" value={sucursal.ciudad} onChange={(e) => handleChangeSucursal(e.target.value, "ciudad")} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Dirección</Form.Label>
                        <Form.Control type="text" value={sucursal.direccion} onChange={(e) => handleChangeSucursal(e.target.value, "direccion")} />
                    </Form.Group>
                    <div className="mt-3"></div>
                    <Button variant="primary" onClick={agregarSucursal}>Agregar</Button>
                </Col>
                <Col>
                    <h4>Listado de Sucursales actuales</h4>
                    <BootstrapTable data={sucursales} cellEdit={cellEditProp}>
                        <TableHeaderColumn dataField="id" hidden isKey>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="nombre" editable={false}>Nombre</TableHeaderColumn>
                        <TableHeaderColumn dataField="ciudad">Ciudad</TableHeaderColumn>
                        <TableHeaderColumn dataField="direccion">Dirección</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={buttonFormat} editable={false} width="10%" tdStyle={{textAlign: "center"}}>Eliminar</TableHeaderColumn>
                    </BootstrapTable>
                </Col>
            </Row>
        </Container>
    )
}

export default Sucursal;